import type { ReactElement } from 'react';
import { useInstruments } from '@/lib/queries/reference-data';

type Props = {
  value: string | null;
  onChange: (instrumentId: string) => void;
};

export function InstrumentSelector({ value, onChange }: Props): ReactElement {
  const { data, isLoading } = useInstruments();

  return (
    <div>
      <label htmlFor="instrument-select" className="block text-sm font-medium mb-1">
        Instrument
      </label>
      <select
        id="instrument-select"
        value={value ?? ''}
        onChange={(e) => onChange(e.target.value)}
        disabled={isLoading}
        className="w-full px-3 py-2 border rounded-lg bg-[var(--bg-surface)] text-[var(--ink)] focus:outline-none focus:ring-2 focus:ring-[var(--ink)] disabled:opacity-50"
      >
        <option value="">— Select instrument —</option>
        {data?.content.map((instrument) => (
          <option key={instrument.instrumentId} value={instrument.instrumentId}>
            {instrument.prettyName}
          </option>
        ))}
      </select>
    </div>
  );
}
